import { useSWRPatientHighlights } from 'src/patientHeader/components/badges/queries/useSWRPatientHighlights';

/**
 * Hook for querying the bupe run-out date
 *
 * @param {string} patientId The patient to get the run-out date for.
 * @returns {(string | undefined)} The date, formatted 'yyyy-MM-dd', or undefined if it's not available yet.
 */
export function useBupeRunOut(patientId: string): string | undefined {
  const patientHighlights = useSWRPatientHighlights(patientId);

  return patientHighlights.data?.patientHighlights?.bupeRunOutDate ?? undefined;
}
